import { createSlice } from '@reduxjs/toolkit';
import {
  SubscriptionFiltersState,
  SubscriptionFiltersToggleActiveFiltersAction,
  SubscriptionFiltersToggleSelectedFiltersAction,
  SubscriptionFiltersSetAllFiltersAction,
} from './subscriptionFilters.types';
import { makeActionCreator } from '../helpers';
import { toggleFilterState } from '../usersFilters/toggleFilterState';

const initialState: SubscriptionFiltersState = {
  state: {
    scope: {
      label: 'Scope',
      active: false,
    },
    type: {
      label: 'Recipient Type',
      active: false,
    },
  },
  selectedFilters: {},
  allFilters: {
    scope: [],
    type: [],
  },
};

const { act } = makeActionCreator<SubscriptionFiltersState>();

export const subscriptionFiltersSlice = createSlice({
  name: 'subscriptionFilters',
  initialState,
  reducers: {
    toggleActiveFilters: (
      filterSliceState,
      action: SubscriptionFiltersToggleActiveFiltersAction
    ) => toggleFilterState(filterSliceState, action.payload),
    toggleSelectedFilters: act<
      SubscriptionFiltersToggleSelectedFiltersAction['payload']
    >(({ name, value }, { selectedFilters }) => {
      const currentValues = selectedFilters[name] || [];
      const isSelected = currentValues.includes(value);

      if (isSelected) {
        const nextValues = currentValues.filter(item => item !== value);
        
        if (nextValues.length === 0) {
          const nextSelectedFilters = { ...selectedFilters };
          delete nextSelectedFilters[name];
          
          return {
            selectedFilters: nextSelectedFilters,
          };
        }

        return {
          selectedFilters: {
            ...selectedFilters,
            [name]: nextValues,
          },
        };
      }

      return {
        selectedFilters: {
          ...selectedFilters,
          [name]: [...currentValues, value],
        },
      };
    }),
    setAllFilters: act<SubscriptionFiltersSetAllFiltersAction['payload']>(
      (allFilters) => ({
        allFilters,
      })
    ),
    reset: () => {
      return initialState;
    },
  },
});

export const {
  toggleActiveFilters,
  toggleSelectedFilters,
  setAllFilters,
  reset,
} = subscriptionFiltersSlice.actions;

export const actions = {
  ...subscriptionFiltersSlice.actions,
};
